import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import ChatView from '../views/ChatView.vue'
import FillContract from '../views/FillContract.vue'
import Optimze from '../views/OptimizeContract.vue'
// config.js


const routes = [
  {
    path: '/',
    name: 'Home',
    component: HomeView
  },
  {
    path: '/chat',
    name: 'Chat',
    component: ChatView
  },
  {
    path: '/fill-contract',
    name: 'fill-contract',
    component: FillContract
  },
  {
  path: '/optimize-contract',
  name: 'OptimizeContract',
  component: Optimze
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

export default router

